import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FaIconComponent, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'icon-picker-modal',
  templateUrl: './icon-picker-modal.component.html',
  styleUrls: ['./icon-picker-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, FaIconComponent]
})
export class IconPickerModalComponent {
  bsModalRef = inject(BsModalRef);
  private library = inject(FaIconLibrary);

  /** Set via `initialState`: the icon selected before the modal opened. */
  model = '';
  /** Read by `ModalService` on close — true only when a selection was confirmed. */
  state = false;

  // FaIconLibrary has no public API to enumerate registered icons, only to look one up by
  // name — .definitions is marked private in its .d.ts, so read it via a narrow cast.
  private readonly definitions = (this.library as unknown as { definitions: Record<string, Record<string, IconDefinition>> }).definitions;

  readonly search = signal('');

  private readonly allNames = computed(() => Object.keys(this.definitions['fas'] ?? {}).sort());

  /** Filtered, capped so the grid never renders the whole (~300-icon) library at once. */
  readonly results = computed(() => {
    const term = this.search().trim().toLowerCase();
    const names = this.allNames();
    const filtered = term ? names.filter(name => name.includes(term)) : names;
    return filtered.slice(0, 60);
  });

  select(name: string): void {
    this.model = name;
    this.state = true;
    this.bsModalRef.hide();
  }

  clear(): void {
    this.model = '';
    this.state = true;
    this.bsModalRef.hide();
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
